module.exports = __webpack_public_path__ + "img/x4.224c1645.png";